<div [hidden]="noFriends() | async" class="dropdown-menu show" >
  <ul class="menu"
      (mouseleave)="onMouseLeave()">
    <li *ngFor="let item of shortList | async; let i=index"
      class="dropdown-item" 
      [class.active]="focusedIndex === i"
      (mouseenter)="onMouseEnter(i)"
      (mouseleave)="onMouseLeave()"
      (mousedown)="makeSuggestion.emit(item)">
        {{item}}
    </li>
  </ul>
</div>
